/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';


export default function DishDetailsHowLong(props) {
    const {
        howLong = null,
        time = null,
        timeText = null,
    } = props;

    if (howLong) {
        return <div dangerouslySetInnerHTML={{ __html: howLong }} />
    }

    return (
        <p className="ny__dishes-details__content">
            <b>
                <span className="num">{time}</span>
                &nbsp;
                {timeText}
            </b>
        </p>
    );
}

DishDetailsHowLong.propTypes = {
    howLong: PropTypes.string,
    time: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    timeText: PropTypes.string,
};
